import { z } from 'zod'

import { adUnitsAttributesSchema } from 'features/inventory/domain/components/ProductAdUnitsTable'
import { scrollSlowingIntensity } from 'features/inventory/domain/types/ScrollSlowingIntensity'
import { Domain } from 'features/inventory/types/domain'
import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { lazyLoadingSchema, validateLazyLoadingSchema } from './lazyLoadingSchema'

export const schema = z
  .object({
    adHoldingEnabled: z.boolean(),
    creativeCodeKeywords: z.array(z.string()),
    distanceFromPageHeaderDesktop: z.number().int().min(0).max(MAX_SAFE_GQL_INTEGER),
    distanceFromPageHeaderMobile: z.number().int().min(0).max(MAX_SAFE_GQL_INTEGER),
    domainId: z.string(),
    excludeCreativeTypesEnabled: z.boolean(),
    extraSpaceBelowAdDesktop: z.number().int().min(0).max(MAX_SAFE_GQL_INTEGER),
    extraSpaceBelowAdMobile: z.number().int().min(0).max(MAX_SAFE_GQL_INTEGER),
    lazyLoadingEnabled: z.boolean(),
    scrollSlowingEnabled: z.boolean(),
    scrollSlowingIntensity: z.enum(scrollSlowingIntensity).optional(),
    trafficAffected: z.number().int().min(0).max(100),
    viewabilityToolsEnabled: z.boolean(),
  })
  .safeExtend(adUnitsAttributesSchema.shape)
  .safeExtend(lazyLoadingSchema.shape)
  .superRefine(validateLazyLoadingSchema)

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({ domainViewabilityTools }: Domain): Schema => ({
  ...domainViewabilityTools,
  adUnitsAttributes: {},
})
